import { useEffect } from 'react';

import HeaderImage from '../../assets/header.png';
import data from './data';
import AOS from 'aos';
import 'aos/dist/aos.css';

import './header.css';

const Header = () => {
    useEffect(() => {
        AOS.init({ duration: 2000 });
    }, []);

    return (
        <header id="header">
            <div className="container header__container">
                <div className="header__profile" data-aos="fade-in">
                    <img src={HeaderImage} alt="Bidyut Ranjan Deka" />
                </div>

                <h1 data-aos="fade-up">Bidyut Deka</h1>
                <p data-aos="fade-up">
                    you are a click away from building your dream website or web
                    app. Send me the details of your project for a modern,
                    mobile responsive highly performant website today!
                </p>
                <div
                    className="header__cta"
                    data-aos="fade-up"
                    data-aos-anchor-placement="bottom-bottom"
                >
                    <a href="#contact" className="btn primary">
                        Let's Talk
                    </a>
                    <a href="#portfolio" className="btn light">
                        My Work
                    </a>
                </div>

                <div className="header__socials">
                    {data.map((item) => (
                        <a
                            key={item.id}
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {item.icon}
                        </a>
                    ))}
                </div>
            </div>
        </header>
    );
};
export default Header;
